import { cn } from "@/utils/Functions";

const LABEL_OVERRIDES: Record<string, string> = {
  contract:    "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  urgent:      "bg-red-500/10 text-red-600 dark:text-red-400",
  payment:     "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  invoice:     "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
  legal:       "bg-violet-500/10 text-violet-600 dark:text-violet-400",
  negotiation: "bg-orange-500/10 text-orange-600 dark:text-orange-400",
  review:      "bg-yellow-500/10 text-yellow-600 dark:text-yellow-400",
  signature:   "bg-teal-500/10 text-teal-600 dark:text-teal-400",
  deadline:    "bg-red-500/10 text-red-600 dark:text-red-400",
  meeting:     "bg-sky-500/10 text-sky-600 dark:text-sky-400",
  onboarding:  "bg-pink-500/10 text-pink-600 dark:text-pink-400",
  compliance:  "bg-amber-500/10 text-amber-600 dark:text-amber-400",
};

const LABEL_PALETTE = [
  "bg-blue-500/10 text-blue-600 dark:text-blue-400",
  "bg-purple-500/10 text-purple-600 dark:text-purple-400",
  "bg-teal-500/10 text-teal-600 dark:text-teal-400",
  "bg-orange-500/10 text-orange-600 dark:text-orange-400",
  "bg-pink-500/10 text-pink-600 dark:text-pink-400",
  "bg-cyan-500/10 text-cyan-600 dark:text-cyan-400",
  "bg-lime-500/10 text-lime-600 dark:text-lime-400",
  "bg-fuchsia-500/10 text-fuchsia-600 dark:text-fuchsia-400",
];

function labelColor(label: string): string {
  const key = label.toLowerCase().trim();
  if (LABEL_OVERRIDES[key]) return LABEL_OVERRIDES[key];
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) & 0xffff;
  return LABEL_PALETTE[h % LABEL_PALETTE.length];
}

export function ThreadLabel({ label, size = "sm" }: { label: string; size?: "sm" | "md" }) {
  return (
    <span
      className={cn(
        "rounded-full font-semibold",
        labelColor(label),
        size === "sm" ? "text-xs px-1.5 py-0.5" : "text-xs px-2 py-1"
      )}
    >
      {label}
    </span>
  );
}
